import { useTranslation } from 'react-i18next'
import './avaliacao.css'

/**
 * O caminho, no painel de Contexto, para enviar modelo de WhatsApp com arquivo.
 *
 * 🆕 **282 (28/09):** o formulário ganhou aba própria no Chatwoot — **"Enviar arquivo"**,
 * ao lado desta —, com o login do portal feito lá dentro. Aqui fica só o aviso de onde
 * ele está: o link da 277, que abria o portal numa **aba nova** e pedia o login quase
 * toda vez, saiu. Era o que o Guilherme chamou de *"muito trabalhoso"*.
 *
 * ⛔ Continua sem formulário aqui: o Contexto roda com a sessão embutida, que não envia (B2).
 */
export function EnvioDeModeloComArquivo() {
  const { t } = useTranslation()

  return (
    <section className="avaliacao" data-testid="envio-de-modelo-no-contexto">
      <p className="avaliacao__dica">📎 {t('modeloComArquivo.useAAba')}</p>
    </section>
  )
}
